module.exports = __webpack_public_path__ + "img/QuartoMinguante.326e4de2.svg";